import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	standalone: false,
	selector: 'bt-snackbar',
	templateUrl: './snackbar.component.html',
	styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {
	@Input() public show: boolean;
	@Input() public message: string;
	@Input() public type: SnackbarType;


  

}

export enum SnackbarType {
	Success = 'success',
	Error = 'error',
	Info = 'info'
}
